// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.billing-details-wrapper {
  display: flex;
  flex-direction: column;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 6px;
}
.billing-details-wrapper .billing-details-header {
  padding-bottom: 20px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 20px;
}
.billing-details-wrapper .billing-details-header span {
  color: #000;
  font-size: 20px;
  font-weight: 700;
}
.billing-details-wrapper .nri-checkbox,
.billing-details-wrapper .agree-checkbox {
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  width: fit-content;
  margin-bottom: 20px;
}
.billing-details-wrapper .nri-checkbox input,
.billing-details-wrapper .agree-checkbox input {
  display: none;
}
.billing-details-wrapper .nri-checkbox .tick-mark,
.billing-details-wrapper .agree-checkbox .tick-mark {
  position: absolute;
  height: 16px;
  width: 16px;
  background-color: #fff;
  border: 2px solid #aaa;
  border-radius: 3px;
}
.billing-details-wrapper .nri-checkbox input:checked + .tick-mark,
.billing-details-wrapper .agree-checkbox input:checked + .tick-mark {
  background-color: #fff;
  border-color: #93288E;
}
.billing-details-wrapper .nri-checkbox .tick-mark:after,
.billing-details-wrapper .agree-checkbox .tick-mark:after {
  content: "";
  position: absolute;
  display: none;
}
.billing-details-wrapper .nri-checkbox input:checked + .tick-mark:after,
.billing-details-wrapper .agree-checkbox input:checked + .tick-mark:after {
  display: block;
}
.billing-details-wrapper .nri-checkbox .tick-mark:after,
.billing-details-wrapper .agree-checkbox .tick-mark:after {
  left: 4px;
  top: 0px;
  width: 5px;
  height: 10px;
  border: solid #93288E;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.billing-details-wrapper .nri-checkbox .label-text,
.billing-details-wrapper .agree-checkbox .label-text {
  margin-left: 26px;
  font-size: 16px;
  font-weight: 500;
  color: #7a7a7a;
}
.billing-details-wrapper .nri-checkbox .label-text.active,
.billing-details-wrapper .agree-checkbox .label-text.active {
  color: #000;
}
.billing-details-wrapper .billing-details-form-wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.billing-details-wrapper .billing-details-form-wrapper input {
  background: #f8f8f8;
  outline: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 400;
  padding: 12px 14px;
  width: 100%;
  color: #000;
}
.billing-details-wrapper .billing-details-form-wrapper input::placeholder {
  color: #aeaeae;
}
.billing-details-wrapper .billing-details-form-wrapper input:focus-visible {
  outline: 1px solid #93288E;
}
.billing-details-wrapper .billing-details-form-wrapper .input-wrapper {
  display: flex;
  gap: 10px;
}
.billing-details-wrapper .billing-details-form-wrapper .relative-wrapper {
  position: relative;
  width: 100%;
}
.billing-details-wrapper .billing-details-form-wrapper .relative-wrapper .abs-wrapper {
  position: absolute;
  top: 28%;
  right: 10px;
  cursor: pointer;
}
.billing-details-wrapper .billing-details-form-wrapper .relative-wrapper .loader {
  border-radius: 50%;
  border: 2px solid #93288E;
  border-left-color: transparent;
  width: 24px;
  height: 24px;
  animation: inputspinner 1s linear infinite;
}
.billing-details-wrapper .agree-wrapper {
  display: flex;
  flex-direction: column;
}
.billing-details-wrapper .agree-wrapper .agree-checkbox {
  margin: 20px 0 8px 0;
}
.billing-details-wrapper .agree-wrapper .agree-checkbox .tick-mark {
  height: 20px;
  width: 20px;
}
.billing-details-wrapper .agree-wrapper .agree-checkbox .tick-mark:after {
  left: 5px;
  top: 0px;
  width: 7px;
  height: 12px;
}
.billing-details-wrapper .agree-wrapper .agree-checkbox .label-text {
  margin-left: 32px;
  font-size: 20px;
}
.billing-details-wrapper .agree-wrapper p {
  margin: 0;
  margin-left: 32px;
  font-size: 14px;
  font-weight: 400;
  color: #7a7a7a;
  font-style: italic;
}

@media only screen and (768px < width < 940px) {
  .billing-details-wrapper .billing-details-form-wrapper .input-wrapper {
    flex-wrap: wrap;
  }
}
@media only screen and (width < 600px) {
  .billing-details-wrapper .billing-details-form-wrapper .input-wrapper {
    flex-wrap: wrap;
  }
}
@keyframes inputspinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/PublicPaymentPage/components/BillingDetailsCard/style.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AACJ;AACI;EACI,oBAAA;EACA,6BAAA;EACA,mBAAA;AACR;AACQ;EACI,WAAA;EACA,eAAA;EACA,gBAAA;AACZ;AAII;;EAEI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AAFR;AAIQ;;EACI,aAAA;AADZ;AAIQ;;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;AADZ;AAIQ;;EACI,sBAAA;EACA,qBAAA;AADZ;AAIQ;;EACI,WAAA;EACA,kBAAA;EACA,aAAA;AADZ;AAIQ;;EACI,cAAA;AADZ;AAIQ;;EACI,SAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;EACA,wBAAA;AADZ;AAIQ;;EACI,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AADZ;AAGY;;EACI,WAAA;AAAhB;AAKI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AAHR;AAKQ;EACI,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;AAHZ;AAIY;EACA,cAAA;AAFZ;AAIY;EACI,0BAAA;AAFhB;AAMQ;EACI,aAAA;EACA,SAAA;AAJZ;AAOQ;EACI,kBAAA;EACA,WAAA;AALZ;AAOY;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;AALhB;AAQY;EACI,kBAAA;EACA,yBAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;AANhB;AAWI;EACI,aAAA;EACA,sBAAA;AATR;AAWQ;EACI,oBAAA;AATZ;AAUY;EACI,YAAA;EACA,WAAA;AARhB;AAWY;EACI,SAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;AAThB;AAYY;EACI,iBAAA;EACA,eAAA;AAVhB;AAcQ;EACI,SAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAZZ;;AAkBA;EAKY;IACI,eAAA;EAnBd;AACF;AAwBA;EAKY;IACI,eAAA;EA1Bd;AACF;AA+BA;EACI;IACE,uBAAA;EA7BJ;EAgCE;IACE,yBAAA;EA9BJ;AACF","sourcesContent":[".billing-details-wrapper {\n    display: flex;\n    flex-direction: column;\n    padding: 20px;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n\n    .billing-details-header {\n        padding-bottom: 20px;\n        border-bottom: 1px solid #ddd;\n        margin-bottom: 20px;\n\n        span {\n            color: #000;\n            font-size: 20px;\n            font-weight: 700;\n        }\n    }\n\n\n    .nri-checkbox,\n    .agree-checkbox {\n        display: flex;\n        align-items: center;\n        position: relative;\n        cursor: pointer;\n        width: fit-content;\n        margin-bottom: 20px;\n\n        input {\n            display: none;\n        }\n\n        .tick-mark {\n            position: absolute;\n            height: 16px;\n            width: 16px;\n            background-color: #fff;\n            border: 2px solid #aaa;\n            border-radius: 3px;\n        }\n\n        input:checked+.tick-mark {\n            background-color: #fff;\n            border-color: #93288E;\n        }\n\n        .tick-mark:after {\n            content: \"\";\n            position: absolute;\n            display: none;\n        }\n\n        input:checked+.tick-mark:after {\n            display: block;\n        }\n\n        .tick-mark:after {\n            left: 4px;\n            top: 0px;\n            width: 5px;\n            height: 10px;\n            border: solid #93288E;\n            border-width: 0 2px 2px 0;\n            transform: rotate(45deg);\n        }\n\n        .label-text {\n            margin-left: 26px;\n            font-size: 16px;\n            font-weight: 500;\n            color: #7a7a7a;\n\n            &.active {\n                color: #000;\n            }\n        }\n    }\n\n    .billing-details-form-wrapper {\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n\n        input {\n            background: #f8f8f8;\n            outline: none;\n            border-radius: 6px;\n            font-size: 16px;\n            font-weight: 400;\n            padding: 12px 14px;\n            width: 100%;\n            color: #000;\n            &::placeholder{\n            color: #aeaeae;\n            }\n            &:focus-visible{\n                outline: 1px solid #93288E;\n            }\n        }\n\n        .input-wrapper {\n            display: flex;\n            gap: 10px;\n        }\n\n        .relative-wrapper{\n            position: relative;\n            width: 100%;\n\n            .abs-wrapper{\n                position: absolute;\n                top: 28%;\n                right: 10px;\n                cursor: pointer;\n            }\n            \n            .loader {\n                border-radius: 50%;\n                border: 2px solid #93288E;\n                border-left-color: transparent;\n                width: 24px;\n                height: 24px;\n                animation: inputspinner 1s linear infinite;\n              }\n        }\n    }\n\n    .agree-wrapper {\n        display: flex;\n        flex-direction: column;\n\n        .agree-checkbox {\n            margin: 20px 0 8px 0;\n            .tick-mark {\n                height: 20px;\n                width: 20px;\n            }\n\n            .tick-mark:after {\n                left: 5px;\n                top: 0px;\n                width: 7px;\n                height: 12px;\n            }\n\n            .label-text {\n                margin-left: 32px;\n                font-size: 20px;\n            }\n        }\n\n        p{\n            margin: 0;\n            margin-left: 32px;\n            font-size: 14px;\n            font-weight: 400;\n            color: #7a7a7a;\n            font-style: italic;\n        }\n    }\n\n}\n\n@media only screen and (768px < width < 940px){\n    .billing-details-wrapper {\n    \n        .billing-details-form-wrapper {\n    \n            .input-wrapper {\n                flex-wrap: wrap;\n            }\n        }    \n    }\n}\n\n@media only screen and (width < 600px){\n    .billing-details-wrapper {\n    \n        .billing-details-form-wrapper {\n    \n            .input-wrapper {\n                flex-wrap: wrap;\n            }\n        }    \n    }\n}\n\n@keyframes inputspinner {\n    0% {\n      transform: rotate(0deg);\n    }\n  \n    100% {\n      transform: rotate(360deg);\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
